var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React from 'react';
import { useCommonContext, usePurchaseHistoryContext, } from '../../hooks/useContexts';
import { PHCardView } from './card-view/PHCardView';
import { ODTable } from './open-deliveries';
import { PHTable } from './table-view/PHTable';
export var CardAndTableView = function (_a) {
    var orderHistoryModalHooks = _a.orderHistoryModalHooks, enableSettingsDrawer = _a.enableSettingsDrawer, setEnableSettingsDrawer = _a.setEnableSettingsDrawer;
    var isMobile = useCommonContext().isMobile;
    var _b = usePurchaseHistoryContext(), customerRole = _b.customerRole, customerType = _b.customerType, orderHistoryData = _b.orderHistoryData, orderHistoryError = _b.orderHistoryError, orderHistoryLoaded = _b.orderHistoryLoaded, localDeliveryData = _b.localDeliveryData, pHRequest = _b.pHRequest, setAlertState = _b.setAlertState, setPHRequest = _b.setPHRequest, viewType = _b.viewType;
    // Props for Table View
    var TableViewProps = {
        customerRole: customerRole,
        customerType: customerType,
        orderHistoryData: orderHistoryData,
        orderHistoryLoaded: orderHistoryLoaded,
        orderHistoryModalHooks: orderHistoryModalHooks,
        pHRequest: pHRequest,
        setAlertState: setAlertState,
        setPHRequest: setPHRequest,
        enableSettingsDrawer: enableSettingsDrawer,
        setEnableSettingsDrawer: setEnableSettingsDrawer,
    };
    // Props for Local Deliveries
    var LocalDeliveriesViewProps = {
        customerType: customerType,
        orders: localDeliveryData === null || localDeliveryData === void 0 ? void 0 : localDeliveryData.orders,
    };
    if (viewType === 'Card' || isMobile || customerType === 'b2c') {
        return (React.createElement(React.Fragment, null, !orderHistoryError && (React.createElement(ErrorBoundary, { name: "order-card-view" },
            React.createElement(PHCardView, { customerRole: customerRole, customerType: customerType })))));
    }
    if (viewType === 'LocalDeliveries') {
        return (React.createElement(React.Fragment, null,
            React.createElement(ErrorBoundary, { name: "local-deliveries" },
                React.createElement(ODTable, __assign({}, LocalDeliveriesViewProps)))));
    }
    return (React.createElement(ErrorBoundary, { name: "table-view" },
        React.createElement(PHTable, __assign({}, TableViewProps))));
};
